import { signOut } from 'firebase/auth';
import { auth } from '@/services/firebase';

const SESSION_EXPIRED_MESSAGE = 'Oturumunuz sona erdi. Lütfen tekrar giriş yapın.';

let forcedLogoutInProgress = false;

export const clearStoredAuth = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('authUser');
    localStorage.removeItem('user_role');
    localStorage.removeItem('user_uid');
    localStorage.removeItem('user_email');
};

export const getSessionExpiredMessage = () => {
    const message = sessionStorage.getItem('auth_redirect_message');
    if (!message) {
        return null;
    }

    sessionStorage.removeItem('auth_redirect_message');
    return message;
};

export const handleUnauthorizedSession = async (message: string = SESSION_EXPIRED_MESSAGE) => {
    if (forcedLogoutInProgress) {
        return;
    }

    forcedLogoutInProgress = true;

    try {
        sessionStorage.setItem('auth_redirect_message', message);
        clearStoredAuth();
        await signOut(auth).catch(() => undefined);

        if (window.location.pathname !== '/login') {
            window.location.replace('/login');
        }
    } finally {
        setTimeout(() => {
            forcedLogoutInProgress = false;
        }, 0);
    }
};
